import { createRoot } from 'react-dom/client';
import { initializeI18nForUnitTest } from './translations/i18n';
import DigitalOnboardingApp from './federation/federated-app';
import React from 'react';

export default function bootstrap(): void {
  const i18n = initializeI18nForUnitTest();

  const root = createRoot(document.getElementById('root'));
  root.render(<DigitalOnboardingApp i18n={i18n} features={[]} />);
}
